// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1YQhC","box":"WorkspacesBox_box__2jra8","node":"WorkspacesBox_node__240c1"};